import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import defineReducer from './slices/define/defineSlice'
import palletReducer from './slices/pallet/palletSlice'
import lpnReducer from './slices/lpn/lpnSlice'
import { apiSlice } from './apiSlice';
import authReducer from './slices/auth/authSlice'
import offlineReducer from './slices/offline/offlineSlice'
import shipTestReducer from './slices/ship-test/shipTestSlice';
import postShipReducer from './slices/post-ship/postShipSlice';
import stackTestReducer from './slices/stack-test/stackTestSlice';
import postStackReducer from './slices/post-stack/postStackSlice';
import summaryReducer from './slices/summary/summarySlice';
import synopsisReducer from './slices/synopsis/synopsisSlice';
import imagesReducer from './slices/images/imagesSlice';
import netWorkReducer from './slices/network/netWorkSlice';
import projectsReducer from './slices/projects/projectsSlice';
import { defineApiSlice } from './slices/define/defineApiSlice';
import { distributionApiSlice } from './slices/distribution/distributionApiSlice';
import stackAndShipReducer from './slices/stack-and-ship/stack-and-ship-slice';
export const store = configureStore({
  reducer: {
    define: defineReducer,
    pallets: palletReducer,
    lpn: lpnReducer,
    auth: authReducer,
    offline: offlineReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    shipTest: shipTestReducer,
    postShip: postShipReducer,
    stackTest: stackTestReducer,
    postStack: postStackReducer,
    summary: summaryReducer,
    synopsis: synopsisReducer,
    images: imagesReducer,
    netWork: netWorkReducer,
    projects: projectsReducer,
    [distributionApiSlice.reducerPath]: distributionApiSlice.reducer,
    stackAndShip: stackAndShipReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware, defineApiSlice.middleware, distributionApiSlice.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
